/**
 * Part of nthu-coe-learning project.
 *
 * @copyright  Copyright (C) 2024 __ORGANIZATION__.
 * @license    __LICENSE__
 */
import { createApp } from 'vue';
import LessonCommentApp from '@vue/app/front/LessonCommentApp.vue';
import { createBootstrap } from 'bootstrap-vue-next';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
await S.import('@main');
await u.domready();
const app = createApp(LessonCommentApp);
app.use(createBootstrap());
app.mount('#lesson-comment-app');
